module.exports = global.mode = {
    current: "Prod",
};
{/* Flip between Demo and Prod */}